import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { getMerchantDeals } from "../../../redux/actions/voucherActions";
import { getDealDetail } from "../../../redux/actions/dealActions";
import moment from "moment";
import auth from "../../../services/auth";

const history = createHashHistory();

let isLoading = "false",
  userID = "";
class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "View Contract"],
      contractData: "",
      show: false,
      alertMessage: "",
      deallist: "",
      dealID: ""
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
    this.setState({ contractData: "" });
    this.handleDismiss();
    this.props.clearAlert();
    if (e.target.value !== "") {
      isLoading = "true";
      let dealID = e.target.value;
      this.props.getDealDetail(dealID);
    }
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    if (userID !== "") {
      this.props.getMerchantDeals(userID);
    } else {
      const userinfo = auth.getUserInfo();
      if (userinfo.user_id !== "") {
        this.props.getMerchantDeals(userinfo.user_id);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dealDetail !== nextProps.dealDetail) {
      if (nextProps.dealDetail) {
        isLoading = "false";
        this.setState({ contractData: nextProps.dealDetail });
      }
    }

    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data.data });
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      //Clear();
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  render() {
    let dealListItems;
    let dealListData = this.state.deallist ? this.state.deallist : [];
    if (dealListData !== "") {
      dealListItems = dealListData.map((el, key) => (
        <option key={key} value={el.dealID}>
          {el.dealText}
        </option>
      ));
    }

    let contract = this.state.contractData ? this.state.contractData : {};
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 text-right">
            <Button
              bsSize="small"
              bsStyle="success"
              onClick={() => history.push(`/merchant/dashboard/${userID}`)}
            >
              Back
            </Button>
          </div>
        </div>

        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-lg-12 text-center">
            <FormGroup controlId="formdeallist">
              <ControlLabel>Select Your Offer</ControlLabel>
              <FormControl
                componentClass="select"
                name="dealID"
                onChange={this.handleChange}
                value={this.state.dealID}
              >
                <option value="">Select your offer</option>
                {dealListItems}
              </FormControl>
            </FormGroup>
          </div>
        </div>

        <div className="clearfix" />

        {this.state.contractData !== "" ? (
          <div id="divdeal" className="row">
            <div className="panel">
              <header className="panel-heading">Merchant </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <p> {contract.merchantName} </p>
                      <p> {contract.legalName} </p>
                      <p> {contract.address1} </p>
                      <p>
                        {" "}
                        {contract.city}, {contract.state} {contract.zipcode}{" "}
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div className="panel">
              <header className="panel-heading">Background</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <p>
                        {" "}
                        {contract.siteName}, LLC owns and operates a turnkey,
                        online and social media marketing platform that helps
                        businesses acquire and retain customers (the "Service").{" "}
                        {contract.siteName} agrees to sell {contract.siteName}{" "}
                        vouchers for Merchant products or services ("Vouchers")
                        to its members through the Service upon the terms and
                        conditions of this Agreement. The product or service
                        that Merchant desires to offer and sell through the
                        Service is referred to in this Agreement as the
                        "Merchant Offer."{" "}
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div className="panel">
              <header className="panel-heading">Merchant Offer</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <p>
                        {" "}
                        The offer to be featured on {contract.siteName} is{" "}
                        {contract.dealText} at {contract.merchantName}
                        (each being referred to as a “unit” with a Retail Value
                        of ${contract.retailPrice} ). Subject to{" "}
                        {contract.siteName}, Inc.'s Standard Merchant Terms and
                        Conditions attached hereto, {contract.siteName}, LLC
                        will pay Merchant ${contract.remittance} for each unit
                        properly redeemed through one of {contract.siteName}'s
                        online or mobile redemption systems and will not sell
                        more than
                        {contract.maxAvailable} units. Each voucher will be
                        valid for a period of {contract.expirationMonth} months
                        after the voucher is purchased. The Merchant Offer will
                        be published until maximum units are sold.
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div className="panel">
              <header className="panel-heading">
                Special Instructions or Voucher Limitations
              </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Row>
                    <Col md={12} xs={12}>
                      <ul>
                        <li>Limit {contract.maxPerCustomer} per customer</li>
                        <li>
                          May purchase {contract.maxAsGift} additional as gifts
                        </li>
                        <li>{contract.termsAndConditions}</li>
                      </ul>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>

            <div className="panel">
              <header className="panel-heading">Payment</header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p>
                  </p>
                </div>
              </div>
            </div>

            <div className="panel">
              <header className="panel-heading">
                {" "}
                Merchant Terms & Conditions{" "}
              </header>
              <div className="panel-body">
                <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p>
                    This Merchant Services Agreement (this “Agreement”) was
                    entered into on{" "}
                    {moment(contract.registeredOn).format("DD-MM-YYYY")} between{" "}
                    {contract.siteName}, LLC and the person or entity identified
                    above as “Merchant”.
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dealDetail: state.dealReducer.dealDetail,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantdealList: state.voucherReducer.merchantdealList,
    error: state.dealReducer.error
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getDealDetail,
    getMerchantDeals
  })
)(View);



// WEBPACK FOOTER //
// ./src/app/views/merchant/contract/View.js